module.exports = __webpack_public_path__ + "static/Dane-osobowe-w-CRM-Co-warto-wiedziec-930c61f95239b2deb1cb3aeb7dd14709.png";